import { Controller } from "@hotwired/stimulus"

// Formulário do equipamento: a unidade filtra os locais (cada <option> de local leva o
// data-unidade), e a seção Rede aparece quando o tipo escolhido é "de rede" (data-de-rede
// na <option> do tipo) ou quando já há dado de rede preenchido.
export default class extends Controller {
  static targets = ["unidade", "local", "tipo", "rede"]

  connect() {
    this.filtrarLocais()
    this.atualizarRede()
  }

  unidadeAlterada() {
    this.localTarget.value = ""
    this.filtrarLocais()
  }

  filtrarLocais() {
    const unidade = this.unidadeTarget.value

    Array.from(this.localTarget.options).forEach((option) => {
      if (!option.value) return

      const visivel = !unidade || option.dataset.unidade === unidade
      option.hidden = !visivel
      option.disabled = !visivel
    })
  }

  atualizarRede() {
    const option = this.tipoTarget.options[this.tipoTarget.selectedIndex]
    const deRede = option && option.dataset.deRede === "true"
    const preenchido = this.redeTarget.querySelectorAll("input").length > 0 &&
      Array.from(this.redeTarget.querySelectorAll("input")).some((campo) => campo.value.trim() !== "")

    this.redeTarget.classList.toggle("d-none", !(deRede || preenchido))
  }
}
